<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-basket</v-icon>{{$t('verticale.verticales')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <VerticaleForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import VerticaleForm from '../../components/verticale/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Verticale';

const { mapFields } = createHelpers({
  getterType: 'verticale/getField',
  mutationType: 'verticale/updateField'
});

export default {
  name: 'VerticaleCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    VerticaleForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('verticale', ['create', 'reset'])
  }
};
</script>
